import { useTranslation } from "react-i18next";
import PackageList from "./PackageList";

export default function HomePackageList() {
  const { t } = useTranslation();

  return (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{t("packages")}</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">{t("packages_home_desc")}</span>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
        <PackageList />
      </div>
    </div>
  );
}
